export const DEFAULT_PAGE_SIZE = 25
export const DEFAULT_PAGE_NUMBER = 1
export const DEFAULT_SORT_BY = 'createdAt'
export const DEFAULT_SORT_DIRECTION = 'desc'
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [
	DEFAULT_PAGE_SIZE,
	DEFAULT_PAGE_SIZE * 2,
	DEFAULT_PAGE_SIZE * 3,
	DEFAULT_PAGE_SIZE * 4,
]
